import {useLocation} from "react-router-dom";
import Footer from "../Footer";
import {useEffect, useMemo} from "react";
import Header from "../Header";
import {Helmet} from "react-helmet-async";

const RouterApp = ({props}) => {
    const {pathname} = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [pathname]);
    const header = useMemo(() => {
        return (<Header path={pathname}/>)
    }, [pathname])
    const footer = useMemo(() => {
        return (<Footer/>)
    }, [])

    return (
        <>
            <Helmet>
                <link rel="preconnect" href="https://fonts.googleapis.com"/>
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin/>
                <link href="https://fonts.googleapis.com/css2?family=Oswald:wght@200..700&display=swap"
                      rel="stylesheet"
                />
            </Helmet>
            {header}
            {props}
            {pathname !== "/" && footer}
        </>
    );
}

export default RouterApp;